// 完成率配置
export const COMPLETION_RATE_CONFIG = [
  { title: '产康当日完成率', color: '#ff4d4f', dataKey: 'postpartumCare' },
  { title: '护理当日完成率', color: '#20b2aa', dataKey: 'nursingCare' },
  { title: '客房当日完成率', color: '#52c41a', dataKey: 'housekeeping' },
  { title: '餐饮当日完成率', color: '#fa8c16', dataKey: 'catering' },
  { title: '到家当日完成率', color: '#eb2f96', dataKey: 'homeService' }
]

// 预警等级配置表
export const ALERT_LEVEL_CONFIG = {
  1: {
    text: '关注',
    textColor: 'green',
    color: 'green',
    borderLeft: '4px solid #52c41a',
    backgroundColor: 'rgba(82, 196, 26, 0.03)',
    tagStyle: { marginRight: 8, fontWeight: 'bold', border: '1px solid #52c41a' }
  },
  2: {
    text: '提醒',
    textColor: 'orange',
    color: 'orange',
    borderLeft: '4px solid #faad14',
    backgroundColor: 'rgba(250, 173, 20, 0.03)',
    tagStyle: { marginRight: 8, fontWeight: 'bold', border: '1px solid #faad14' }
  },
  3: {
    text: '紧急',
    textColor: 'red',
    color: 'red',
    borderLeft: '4px solid #ff4d4f',
    backgroundColor: 'rgba(255, 77, 79, 0.05)',
    tagStyle: { marginRight: 8, fontWeight: 'bold', border: '2px solid #ff4d4f', boxShadow: '0 0 4px rgba(255, 77, 79, 0.3)' }
  },
  4: {
    text: '特急',
    textColor: 'purple',
    color: 'purple',
    borderLeft: '4px solid #722ed1',
    backgroundColor: 'rgba(114, 46, 209, 0.08)',
    tagStyle: { marginRight: 8, fontWeight: 'bold', border: '2px solid #722ed1', boxShadow: '0 0 6px rgba(114, 46, 209, 0.5)' }
  }
}

// 护理预警状态配置表
export const NURSING_ALERT_STATUS_CONFIG = {
  '未处理': {
    text: '未处理',
    color: 'red',
    tagStyle: { marginRight: 8 }
  },
  '跟进中': {
    text: '跟进中',
    color: 'processing',
    tagStyle: { marginRight: 8 }
  },
  '已结束': {
    text: '已结束',
    color: 'success',
    tagStyle: { marginRight: 8 }
  }
}

